import React, { useState, useMemo, useRef, ChangeEvent, useEffect } from 'react'
import styles from './index.module.scss'
import { useHistory } from 'react-router-dom'
import { TextareaItem, Toast } from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css'
import { addParams, getQuery, setEvent } from '@/core/utile'
import { ORIGIN_URL_KEY } from '@/pages/complaint/helper'
import { useDebounce } from '@/hooks/use-debounce'
import { COMPLAINT_TYPES, COMPLAINT_TYPES_QIWEI } from '../select-type/constant'
import { isInMiniProgram } from '@/core/env'
import MediaUploader from '@/core/upload'
import { showPreviewImg, PreviewImg } from '@/components/preview-img'
import { showToast } from '@weike/weike-ui'
import { isWechat } from '@weike/toolkit'

declare const Session: any
declare const wx: any

const MAX_LENGTH = 300
const MAX_IMAGE_COUNT = 5

export default function ComplaintSubmit() {
  const [inputValue, setInputValue] = useState('')
  const [imageList, setImageList] = useState<string[]>([])
  const [uploading, setUploading] = useState(false)
  const uploadInputRef = useRef<HTMLInputElement>(null)
  const history = useHistory()
  const query = getQuery()
  const { type, subType } = query

  // 获取所有投诉类型数组（用于查找）
  const allTypes = useMemo(() => {
    return query.s === 'qw' ? COMPLAINT_TYPES_QIWEI : COMPLAINT_TYPES
  }, [query.s])

  // 根据type获取投诉类型信息
  const complaintType = useMemo(() => {
    if (!type) return null
    return allTypes.find(item => item.id === type) || null
  }, [type, allTypes])

  // 根据subType获取二级原因信息
  const subReason = useMemo(() => {
    if (!subType || !complaintType || !complaintType.subReason) {
      return null
    }
    return complaintType.subReason.find(item => item.id === subType) || null
  }, [subType, complaintType])

  // 显示标题和原因（优先显示二级原因）
  // 如果有 subType，必须显示二级原因的 title；reason 优先显示二级的，如果二级的为空则显示一级的
  const displayTitle = subReason
    ? subReason.title
    : complaintType
    ? complaintType.title
    : ''
  const displayReason = subReason
    ? subReason.reason || (complaintType ? complaintType.reason : '')
    : complaintType
    ? complaintType.reason
    : ''

  /**
   * 处理图片上传
   */
  // const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files
  //   if (!file || !file[0]) return

  //   // 检查图片数量
  //   if (imageList.length >= MAX_IMAGE_COUNT) {
  //     showToast({
  //       tip: `最多只能上传${MAX_IMAGE_COUNT}张图片`,
  //       type: 'warning',
  //       closeMask: true,
  //     })
  //     return
  //   }

  //   // 检查文件格式
  //   const format = ['jpg', 'jpeg', 'png', 'gif']
  //   const type = file[0].name.split('.')
  //   if (format.indexOf(type[type.length - 1].toLocaleLowerCase()) === -1) {
  //     showToast({
  //       tip: '请上传正确的文件格式！',
  //       type: 'warning',
  //       closeMask: true,
  //     })
  //     return
  //   }

  //   Session.getToken(
  //     async ({ account: { id } }: { account: { id: number } }) => {
  //       setUploading(true)
  //       showToast({
  //         tip: '上传中',
  //         type: 'loading',
  //         closeAuto: false,
  //       })
  //       try {
  //         const { url } = await MediaUploader.uploadCos(
  //           file[0],
  //           {
  //             class: 'material',
  //             namespace: id,
  //           },
  //           (progressData: number) => {
  //             console.log(((progressData || 0) * 100).toFixed(2))
  //           },
  //         )
  //         showToast({
  //           type: 'success',
  //           tip: '上传成功',
  //           closeMask: true,
  //         })
  //         setImageList([...imageList, url])
  //       } catch (e) {
  //         let errorMsg = '上传失败'
  //         if (e && typeof e === 'object' && 'msg' in e) {
  //           errorMsg = String((e as { msg: string }).msg)
  //         } else if (e instanceof Error) {
  //           errorMsg = e.message
  //         } else {
  //           errorMsg = String(e)
  //         }
  //         showToast({
  //           type: 'error',
  //           tip: errorMsg,
  //           closeMask: true,
  //         })
  //       } finally {
  //         setUploading(false)
  //         // 上传完成后清空input值
  //         if (uploadInputRef.current) {
  //           uploadInputRef.current.value = ''
  //         }
  //       }
  //     },
  //   )
  // }

  /**
   * 删除图片
   */
  // const handleDeleteImage = (index: number) => {
  //   const newImageList = [...imageList]
  //   newImageList.splice(index, 1)
  //   setImageList(newImageList)
  // }

  const handleSubmit = useDebounce(() => {
    if (!(inputValue || '').trim()) {
      Toast.info('请填写投诉说明')
      return
    }
    setEvent('ra_complaint_submit', {
      content: inputValue,
      type: type,
      subType: subType || '',
      origin_url: sessionStorage.getItem(ORIGIN_URL_KEY),
      c: query.c,
      u: query.u,
      s: query.s,
      imageList: imageList,
    })
    setTimeout(() => {
      history.push('/complaint_submit_result')
    }, 200)
  }, 300)

  // 重新选择投诉类型
  const handleReselect = () => {
    const url = addParams('/complaint', {
      c: query.c,
      u: query.u,
      s: query.s,
    })
    history.push(url)
  }

  useEffect(() => {
    setEvent('complaint_submit_page_v', {
      ...query,
    })
    // if (isWechat() && wx) {
    //   wx.ready(() => wx.hideAllNonBaseMenuItem())
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div>提交证据材料</div>
        {isInMiniProgram() && (
          <div className={styles.sub_title}>此投诉为本小程序自有投诉渠道</div>
        )}
      </div>

      <div className={styles.info_form}>
        {/* 投诉类型显示 */}
        <div className={styles.type_section}>
          <div className={styles.type_info}>
            <img
              className={styles.type_icon}
              src="https://img.lycheer.net/xupload/685/69539294f14d5e8471c215bf.png"
              alt=""
            />
            <span className={styles.type_title}>{displayTitle}</span>
          </div>
          <span className={styles.reselect} onClick={handleReselect}>
            重新选择
          </span>
        </div>

        {/* 举报原因 */}
        <div className={styles.reason_section}>
          <div className={styles.reason_label}>举报原因</div>
          <div className={styles.reason_content}>{displayReason}</div>
        </div>

        {/* 投诉说明输入 */}
        <div className={styles.input_section}>
          <div className={styles.info_form_item_value}>
            <TextareaItem
              className={styles.textarea}
              value={inputValue}
              placeholder="填写投诉说明"
              rows={8}
              count={MAX_LENGTH}
              onChange={value => {
                if (value && value.length <= MAX_LENGTH) {
                  setInputValue(value)
                } else if (!value) {
                  setInputValue('')
                }
              }}
            />
          </div>
        </div>

        {/* 图片上传 */}
        {/* {query.s === 'qw' && (
          <div className={styles.image_section}>
            <div className={styles.image_label}>
              上传图片（最多{MAX_IMAGE_COUNT}张）
            </div>
            <div className={styles.image_list}>
              {imageList.map((url, index) => (
                <div key={index} className={styles.image_item}>
                  <img
                    src={url}
                    alt=""
                    className={styles.image_preview}
                    onClick={() => showPreviewImg(url)}
                  />
                  <div
                    className={styles.image_delete}
                    onClick={() => handleDeleteImage(index)}
                  >
                    ×
                  </div>
                </div>
              ))}
              {imageList.length < MAX_IMAGE_COUNT && (
                <div
                  className={styles.image_upload_btn}
                  onClick={() => {
                    if (!uploading) {
                      uploadInputRef.current && uploadInputRef.current.click()
                    }
                  }}
                >
                  {uploading ? (
                    <div className={styles.image_upload_loading}>
                      <div className={styles.loading_spinner}></div>
                    </div>
                  ) : (
                    <div className={styles.image_upload_icon}>+</div>
                  )}
                </div>
              )}
            </div>
            <input
              style={{ display: 'none' }}
              multiple={false}
              accept="image/*"
              type="file"
              ref={uploadInputRef}
              onChange={handleImageUpload}
            />
          </div>
        )} */}
      </div>

      <div className={styles.main_button} onClick={handleSubmit}>
        提交
      </div>
      <PreviewImg />
    </div>
  )
}
